import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Pill } from "@phosphor-icons/react";

export default function Login() {
  const { login, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const redirectTo = params.get("redirect") || "/app";

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(email, password);
    setBusy(false);
    if (ok) navigate(redirectTo);
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FDFBF7]">
      <div className="hidden lg:block relative">
        <img
          src="https://images.unsplash.com/photo-1566616213894-2d4e1baee5d8"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-[#1A2520]/60 to-transparent" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <div className="text-xs uppercase tracking-[0.2em] opacity-80">EverCara</div>
          <div className="mt-2 font-heading text-3xl font-bold leading-tight">
            Welcome back. Your loved ones are waiting.
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-12">
        <form onSubmit={submit} className="w-full max-w-md">
          <div className="flex items-center gap-2 mb-8">
            <div className="w-10 h-10 rounded-full bg-[#2C5545] flex items-center justify-center">
              <Pill weight="duotone" className="text-white" size={22} />
            </div>
            <div className="font-heading font-extrabold text-xl">EverCara</div>
          </div>
          <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight">Sign in</h1>
          <p className="text-[#576A62] mt-2">Welcome back to your EverCara.</p>

          <div className="mt-8 space-y-5">
            <div>
              <label className="block text-sm font-medium mb-2">Email</label>
              <input
                data-testid="login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full h-12 px-4 rounded-xl border border-[#EBE8E0] bg-white focus:ring-2 focus:ring-[#2C5545] focus:border-transparent outline-none"
                placeholder="you@example.com"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">Password</label>
              <input
                data-testid="login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full h-12 px-4 rounded-xl border border-[#EBE8E0] bg-white focus:ring-2 focus:ring-[#2C5545] focus:border-transparent outline-none"
                placeholder="••••••••"
              />
            </div>
            {error && (
              <div className="text-sm text-[#C86A51] bg-[#C86A51]/10 rounded-lg px-4 py-3" data-testid="login-error">
                {error}
              </div>
            )}
            <button
              data-testid="login-submit"
              disabled={busy}
              className="w-full h-12 rounded-full bg-[#2C5545] hover:bg-[#224235] text-white font-semibold transition-colors disabled:opacity-60"
            >
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </div>
          <div className="mt-6 text-sm text-[#576A62]">
            No account yet?{" "}
            <Link to="/register" data-testid="link-to-register" className="text-[#2C5545] font-semibold hover:underline">
              Create one
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
